var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTagVehic = function SvgTagVehic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "tag_vehic_svg__Capa_2",
    viewBox: "0 0 15.69 13.81"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tag_vehic_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.32 0H2.22L.04 5.52 0 13.8h2v-1.56h11.69v1.56h1v-1.56 1.56h1V5.57zM2.9 1h9.77l1.48 3.42H1.54L2.89 1ZM1 11.25V5.8l.15-.38h13.43l.11.25v5.58z",
    fill: "#22aa9e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.7 7.17c-.67 0-1.21.54-1.21 1.21s.54 1.21 1.21 1.21 1.21-.54 1.21-1.21-.54-1.21-1.21-1.21M11.87 7.17c-.67 0-1.21.54-1.21 1.21s.54 1.21 1.21 1.21 1.21-.54 1.21-1.21-.54-1.21-1.21-1.21",
    fill: "#22aa9e"
  }))));
};
export default SvgTagVehic;